import React, { useState, useEffect } from 'react';

const BackfillGAMForm = ({
  item,
  widgetAds,
  BACKFILL_GAM_INTERNAL_OPTIONS,
  getBackfillGamPageOptions,
  getBackfillGamPageLabel,
  normalizeBackfillGamPage,
  handleSubmitGamBackfillType,
  setEditingGamBackfillType,
  editingGamBackfillType,
  disabled,
  isEditing,
  lang_id
}) => {
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [widgetPages, setWidgetPages] = useState({});

  useEffect(() => {
    if (isEditing) {
      const existing = editingGamBackfillType?.widgetAds || [];
      setSelectedWidgets(existing.map(w => w.widget_type));

      const initialPages = {};
      existing.forEach(w => {
        initialPages[w.widget_type] = normalizeBackfillGamPage(w.widget_type, w.page);
      });
      setWidgetPages(initialPages);
    }
  }, [isEditing, editingGamBackfillType, normalizeBackfillGamPage]);

  const toggleWidget = (value) => {
    setSelectedWidgets(prev => {
      if (prev.includes(value)) {
        return prev.filter(v => v !== value);
      } else {
        setWidgetPages(prevPages => ({
          ...prevPages,
          [value]: normalizeBackfillGamPage(value, prevPages[value])
        }));
        return [...prev, value];
      }
    });
  };

  const handlePageChange = (widgetValue, pageValue) => {
    setWidgetPages(prev => ({ ...prev, [widgetValue]: pageValue }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const fullWidgetPayload = BACKFILL_GAM_INTERNAL_OPTIONS.map(option => {
      const isSelected = selectedWidgets.includes(option.value);
      return {
        widget_type: option.value,
        view: isSelected ? 1 : 0,
        page: isSelected ? parseInt(normalizeBackfillGamPage(option.value, widgetPages[option.value])) : 0
      };
    });

    handleSubmitGamBackfillType({
      position: item,
      widget_objects: fullWidgetPayload,
      lang_id
    });
  };

  return (
    <div className={`gamNetBfill ${disabled ? 'disabled' : ''}`}>
      <div className="gamAd">
        <label>GAM Network Ads:</label>
        {!isEditing ? (
          <div className="d-flex gap-3 align-items-center">
            <div>
              {widgetAds?.map(w => {
                const opt = BACKFILL_GAM_INTERNAL_OPTIONS.find(o => o.value === w.widget_type);
                const pageLabel = getBackfillGamPageLabel(w.page, w.widget_type);
                return `${opt?.label} ${opt.value !== 'classifieds' ? `(${pageLabel})` : ''}`;
              }).join(', ')}
            </div>
            <button type="button" disabled={disabled} className="addBtn" onClick={() => setEditingGamBackfillType({ position: item, widgetAds: widgetAds || [] })}>
              Edit
            </button>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <div className="d-flex flex-column gap-3 mt-2">
              {BACKFILL_GAM_INTERNAL_OPTIONS.map(option => {
                const isSelected = selectedWidgets.includes(option.value);
                const pageOptions = getBackfillGamPageOptions(option.value);
                return (
                  <div key={option.value} className="widget-row p-2 border rounded">
                    <div className="d-flex flex-nowrap align-items-center gap-2">
                      <label className="d-flex gap-2 align-items-center mb-0 flex-shrink-0">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => toggleWidget(option.value)}
                        />
                        <strong>{option.label}</strong>
                      </label>

                      {isSelected && (
                        <>
                          <span className="text-muted px-1 flex-shrink-0">|</span>
                          <div className="d-flex gap-2 align-items-center flex-shrink-0">
                            <span className="small text-muted">Page:</span>
                            {pageOptions.map((p) => (
                              <label key={p.value} className="d-flex gap-1 align-items-center small mb-0">
                                <input
                                  type="radio"
                                  name={`page-${item}-${option.value}`}
                                  value={p.value}
                                  checked={widgetPages[option.value] === p.value}
                                  onChange={() => handlePageChange(option.value, p.value)}
                                /> {p.label}
                              </label>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="d-flex gap-2 mt-3">
              <button type="submit" className="addBtn">Submit</button>
              <button type="button" className="addBtn" onClick={() => setEditingGamBackfillType({})}>Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default BackfillGAMForm;
